import React from 'react';
import { ToastOptions, toast } from 'react-toastify';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import theme from '@src/theme';

import { dFlex } from '@assets/mixins';

import {
  boxStyles,
  boxWithHashLinkStyles,
  btnWithHashLinkStyles,
  linkStyles,
} from '@components/common/Toast/styles';

import { TRX_LINK } from '@constants/common/chain.constants';
import {
  TOAST_DEFAULT_OPTIONS,
  ToastType,
} from '@constants/common/toast.constants';
import { Size } from '@constants/common/ui.constants';

type ToastContent = {
  title: string;
  description?: string;
  withLink?: {
    hash: string;
    chainId: number;
    title?: string;
  };
  withExternalLink?: {
    link: string;
    title?: string;
  };
};

const COLOR_TYPE = {
  [ToastType.Success]: theme.accent.a1,
  [ToastType.Error]: theme.accent.a6,
  [ToastType.Info]: theme.accent.a4,
};

const showToast = (
  content: ToastContent,
  type: ToastType,
  toastOptions?: {
    hideIcon?: boolean;
    hideClose?: boolean;
    showProgressBar?: boolean;
  },
) => {
  const options: ToastOptions = {
    ...TOAST_DEFAULT_OPTIONS,
    type,
    className: `toast-container-${type}`,
    icon: !toastOptions?.hideIcon && (
      <InfoOutlinedIcon
        style={{ color: COLOR_TYPE[type] }}
        fontSize={Size.Small}
      />
    ),
    closeButton: !!toastOptions?.hideClose,
    hideProgressBar: toastOptions?.showProgressBar,
  };

  const handleClick = () => {
    if (content?.withLink) {
      const { hash, chainId } = content.withLink;
      window.open(`${TRX_LINK[chainId]}${hash}`);
    }
  };

  const renderBlock = () => (
    <>
      <div
        style={
          content?.withLink ? { ...boxWithHashLinkStyles } : { ...boxStyles }
        }
      >
        <div>
          <Typography variant="body1" color={theme.primary.p2}>
            {content.title}
          </Typography>
          {content?.description && (
            <Typography
              variant="body1"
              color={theme.primary.p2}
              style={{ marginTop: '4px', ...dFlex() }}
            >
              {content.description}
            </Typography>
          )}
        </div>
        {content?.withLink && (
          <button
            onClick={handleClick}
            style={{
              color: COLOR_TYPE[type],
              ...btnWithHashLinkStyles,
            }}
          >
            {content.withLink?.title || 'View'}
          </button>
        )}
      </div>
      {content?.withExternalLink && (
        <a
          style={{
            color: COLOR_TYPE[type],
            ...linkStyles,
          }}
        >
          {content.withExternalLink?.title || 'View'}
        </a>
      )}
    </>
  );

  toast(renderBlock(), options);
};

export default showToast;
